const MAX_SLUG_LENGTH = 36
const SLUG_CLEANING_REGEX = /[^\w\d\s-]|\b(and|of|the|a|with|for)\b/g

const slugify = function (
  text: string,
  maxLength: number = MAX_SLUG_LENGTH
): string {
  let slugified = (text || '')
    .toLowerCase()
    .replace(SLUG_CLEANING_REGEX, '')
    .split(/\s/)
    .filter((word) => word.trim() !== '')
    .join('-')

  if (slugified.length > maxLength) {
    slugified = slugified.substr(0, maxLength).replace(/(.+)-.+?$/g, '$1')
  }

  return slugified
}

export default slugify
